/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `apiConstants` for the Caintra Connect frontend.
 * @module utils/apiConstants
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */

/** Standard JSON request content type for API calls. */
export const CONTENT_TYPE_JSON = "application/json";

/** Cognito/API message when the JWT has expired. */
export const TOKEN_EXPIRED_MESSAGE = "The incoming token has expired";

/** Cognito/API message when the JWT is expired or invalid. */
export const TOKEN_EXPIRED_OR_INVALID_MESSAGE =
  "The incoming token has expired or is invalid";
